import React, { useEffect, useState } from 'react'
import { getFilesDetailsImagesAPI } from '../services/files'
import IconUser01 from '../images/img-use-01.svg'
import IconUser02 from '../images/img-use-02.svg'
import IconUser03 from '../images/img-use-03.1.svg'
import IconUser04 from '../images/img-use-04.svg'
import IconUser05 from '../images/img-use-05.svg'
import { Image } from 'react-bootstrap'
export default function UseTypeImage(orgId, code) {
  const [data, setData] = useState([])

  useEffect(() => {
    const getFilesDetailsImages = async () => {
      const result = await getFilesDetailsImagesAPI({ orgId, code })
      if (!result) return
      if (result.status) {
        setData(result.result)

        const newData = result.result
          .map((d, i) => {
            if (d.id === 2) {
              return null // Skip this item
            }

            return {
              id: d.id,
              x: d.ratio_w,
              y: d.ratio_h,
              icon: fnIconImage(i),
              url: d.url,
              name: d.image,
              detail: d.description,
              height: d.height,
              width: d.width
            }
          })
          .filter((item) => item !== null) // Filter out null items

        setData(newData)
      }
    }
    if (code && orgId) {
      getFilesDetailsImages()
    }
  }, [code, orgId])

  return data
}

const fnIconImage = (id) => {
  if (id === 0) {
    return <Image src={IconUser01} fluid style={{ maxHeight: '60px' }} />
  } else if (id === 1) {
    return <Image src={IconUser03} fluid style={{ maxHeight: '60px' }} />
  } else if (id === 2) {
    return <Image src={IconUser04} fluid style={{ maxHeight: '60px' }} />
  } else if (id === 3) {
    return <Image src={IconUser05} fluid style={{ maxHeight: '60px' }} />
  } else if (id === 4) {
    return <Image src={IconUser05} fluid style={{ maxHeight: '60px' }} />
  } else {
    return <Image src={IconUser01} fluid style={{ maxHeight: '60px' }} />
  }
}
